import Reflux from 'reflux';
import http from '../../helper/ajax';

const PanelActions = Reflux.createActions(['togglePanel', 'addSearchAttribute', 'publishNewSearchItem']);

PanelActions.addSearchAttribute.preEmit = (item) => {
  http.post('add_search_element', item).end((error, res) => {
    if (res.text) {
      PanelActions.publishNewSearchItem(JSON.parse(res.text));
    }
  });
};

export default PanelActions;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/action/panelActions.js